<div
  id="populate-inventory-options"
  data-cy="populate-inventory-options-section"
>
  <ion-list
    *ngFor="let inventoryOptionCategory of inventoryConstants?.categories"
  >
    <ion-list-header
      [attr.data-cy]="
        'populate-inventory-options-category-' + inventoryOptionCategory.code
      "
    >
      {{ inventoryOptionCategory?.displayText }}
    </ion-list-header>
    <ion-item-divider></ion-item-divider>
    <ion-item
      *ngFor="let inventoryOption of inventoryOptionCategory?.subCategories"
      [attr.data-cy]="'populate-inventory-option-' + inventoryOption.code"
      [class.selected]="
        selectedCreateInventoryOption?.code === inventoryOption.code
      "
      button="true"
      detail="true"
      (click)="handleCreateInventoryOptionSelection(inventoryOption)"
    >
      <ion-label
        [attr.data-cy]="
          'populate-inventory-option-' + inventoryOption.code + '-label'
        "
      >
        {{ inventoryOption?.displayText }}
      </ion-label>
    </ion-item>
  </ion-list>
</div>
